import { useMemo, useState } from 'react';
import { GUIDES, FAQS, searchHelp } from '../constants/helpContent';

const SUPPORT_PHONE = '9350880086';
const SUPPORT_EMAIL = 'contactneedcfo@gmail.com';

function HelpCenter({ open, onClose }) {
  const [query, setQuery] = useState('');
  const [openGuide, setOpenGuide] = useState(null);
  const [openFaq, setOpenFaq] = useState(null);

  const results = useMemo(() => searchHelp(query), [query]);
  const searching = query.trim().length > 2;

  if (!open) return null;

  return (
    <div className="ncf-modal-overlay" onClick={onClose}>
      <div
        className="ncf-modal"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: 760, maxHeight: '85vh', overflowY: 'auto' }}
      >
        <div className="page-title-row" style={{ marginBottom: 4 }}>
          <h3 className="ncf-modal-title" style={{ margin: 0 }}>Help &amp; Guide</h3>
          <button type="button" className="dash-btn cal-btn-grey" onClick={onClose}>Close</button>
        </div>

        <div className="field-group" style={{ marginTop: 12 }}>
          <input
            className="field-input"
            autoFocus
            placeholder="Ask a question — e.g. why can't I see Client Master, how do I pay, ROC is empty"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>

        {searching && (
          <div style={{ marginBottom: 20 }}>
            {results.length === 0 ? (
              <div className="dash-card" style={{ margin: 0 }}>
                <p style={{ margin: 0 }}>
                  Nothing here matches that. Try a keyword like <em>GST</em>, <em>import</em>,{' '}
                  <em>penalty</em>, <em>trial</em> or <em>password</em> — or call us on{' '}
                  <a href={`tel:${SUPPORT_PHONE}`} style={{ color: '#c2410c' }}>{SUPPORT_PHONE}</a>.
                </p>
              </div>
            ) : (
              <>
                <p className="dash-table-sub" style={{ margin: '0 0 8px' }}>
                  {results.length} match{results.length === 1 ? '' : 'es'}
                </p>
                {results.map((r) => (
                  <div key={`${r.kind}-${r.id}`} className="dash-card" style={{ margin: '0 0 10px' }}>
                    <div style={{ display: 'flex', gap: 8, alignItems: 'baseline' }}>
                      <span className={`dash-pill ${r.kind === 'faq' ? 'dash-pill-amber' : 'dash-pill-blue'}`}>
                        {r.kind === 'faq' ? 'FAQ' : 'Guide'}
                      </span>
                      <strong>{r.title}</strong>
                    </div>
                    <p style={{ margin: '8px 0 0', fontSize: 14, color: '#374151' }}>{r.text}</p>
                  </div>
                ))}
              </>
            )}
          </div>
        )}

        {!searching && (
          <>
            <h4 style={{ margin: '18px 0 8px' }}>Guide by screen</h4>
            {GUIDES.map((g) => (
              <div key={g.id} className="dash-card" style={{ margin: '0 0 8px', padding: 12 }}>
                <button
                  type="button"
                  onClick={() => setOpenGuide(openGuide === g.id ? null : g.id)}
                  style={{
                    background: 'none', border: 'none', padding: 0, cursor: 'pointer',
                    textAlign: 'left', width: '100%', font: 'inherit',
                  }}
                >
                  <strong>{g.panel}</strong>
                  <div className="dash-table-sub" style={{ marginTop: 2 }}>{g.summary}</div>
                </button>
                {openGuide === g.id && (
                  <ul style={{ margin: '10px 0 0', paddingLeft: 18, fontSize: 14, color: '#374151' }}>
                    {g.body.map((line, i) => (
                      <li key={i} style={{ marginBottom: 6 }}>{line}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}

            <h4 style={{ margin: '22px 0 8px' }}>Frequently asked</h4>
            {FAQS.map((f) => (
              <div key={f.id} className="dash-card" style={{ margin: '0 0 8px', padding: 12 }}>
                <button
                  type="button"
                  onClick={() => setOpenFaq(openFaq === f.id ? null : f.id)}
                  style={{
                    background: 'none', border: 'none', padding: 0, cursor: 'pointer',
                    textAlign: 'left', width: '100%', font: 'inherit', fontWeight: 600,
                  }}
                >
                  {openFaq === f.id ? '▾ ' : '▸ '}{f.q}
                </button>
                {openFaq === f.id && (
                  <p style={{ margin: '8px 0 0', fontSize: 14, color: '#374151' }}>{f.a}</p>
                )}
              </div>
            ))}

            <div className="dash-card" style={{ marginTop: 18 }}>
              <strong>Still stuck?</strong>
              <p className="dash-table-sub" style={{ margin: '6px 0 0' }}>ASA NEEDCFO Finvisors Pvt. Ltd.</p>
              <p style={{ margin: '2px 0 0', fontWeight: 600 }}>
                <a href={`tel:${SUPPORT_PHONE}`} style={{ color: '#c2410c', textDecoration: 'none' }}>
                  📞 {SUPPORT_PHONE}
                </a>
              </p>
              <p className="dash-table-sub" style={{ margin: '2px 0 0' }}>
                <a href={`mailto:${SUPPORT_EMAIL}`} style={{ color: '#c2410c' }}>{SUPPORT_EMAIL}</a>
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default HelpCenter;
